import React from 'react'

import resume from '../images/JeremyZander2020.pdf';
// import headshot from '../images/headshot.jpg';

const Header = (props) => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <span className="icon fa-code head-icon"></span>
      {/*<img src={headshot} alt='Jeremy Zander headshot'/>*/}
    </div>
    <div className="content">
      <div className="inner">
        <h1>Jeremy Zander</h1>
        <p>I build fully-customized pixel perfect front end web applications with modern Javascript technologies like
          ReactJS and AngularJS.<br/>&nbsp;<br/>I love creating and optimizing user experiences.</p>
      </div>
    </div>
    <nav>
      <ul>
        {/*<li><a href="javascript:;" onClick={() => {*/}
          {/*props.onOpenArticle('work')*/}
        {/*}}>Work</a></li>*/}
        {/*<li><a href="javascript:;" onClick={() => {*/}
          {/*props.onOpenArticle('about')*/}
        {/*}}>About</a></li>*/}
        <li><a href={resume} download>Resume</a></li>
        <li><a href="mailto:jeremy.zander@gmail.com">Email</a></li>
        {/*<li><a href="javascript:;" onClick={() => {*/}
          {/*props.onOpenArticle('contact')*/}
        {/*}}>Contact</a></li>*/}
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js